type Parameters = Record<string, string>;

export function parseSearchParameters(search: string, id: string): string {
  const searchParameters = new URLSearchParams(search);
  const parameters: Parameters = {};

  for (const [key, value] of searchParameters.entries()) {
    parameters[key] = value;
  }

  return parameters[id];
}
